import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useEffect, useState } from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'fit-content',
  maxHeight: '80vh',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 1,
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  textAlign: 'center',
  overflow: 'auto',
};

const TodayScheduleModal = ({ loading, schedule }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [rearrangedSchedule, setRearrangedSchedule] = useState([]);

  const rearrangeSchedule = (arr) => {
    const newArr = [];
    const mid = Math.ceil(arr.length / 2);

    for (let i = 0; i < mid; i++) {
      newArr.push(arr[i], arr[i + mid]);
    }
    setRearrangedSchedule(newArr);
  };
  useEffect(() => {
    rearrangeSchedule(schedule);
  }, [schedule]);
  return (
    <div>
      <Button disabled={loading} size='small' variant='outlined' style={{ textTransform: 'none', lineHeight: '1' }} onClick={handleOpen}>
        Today's Schedule
      </Button>
      <Modal open={open} onClose={handleClose} aria-labelledby='modal-modal-title' aria-describedby='modal-modal-description'>
        <Box sx={style}>
          {rearrangedSchedule.map((trip, index) => (
            <Typography key={index} variant='h6' component='h2' mx={1}>
              {trip}
            </Typography>
          ))}
        </Box>
      </Modal>
    </div>
  );
};

export default TodayScheduleModal;
